// extracted by mini-css-extract-plugin
export default {"msgM":"_49507d335a"};